<template>
    <div class="diaryMenuHeader-wapper" align="center">
      <column-wrapper>
        <first-course :edit="true" :title="'1er Plato'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Primer Plato</h3>
      </column-wrapper>
      <column-wrapper>
        <second-course :edit="true" :title="'2º Plato'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Segundo Plato</h3>
      </column-wrapper>
      <column-wrapper>
        <desserts :edit="true" :title="'Postre'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Postre</h3>
      </column-wrapper>
      <column-wrapper>
        <suggested-dinner :edit="true" :title="'Cena Sugerida'" @updatedElement="detectElementChange" />
        <h3 class="text-center">Cena Sugerida</h3>
      </column-wrapper>
    </div>
</template>
<script>
import Desserts from '@/components/menuElements/Desserts.vue'
import FirstCourse from '@/components/menuElements/FirstCourse.vue'
import SecondCourse from '@/components/menuElements/SecondCourse.vue'
import SuggestedDinner from '@/components/menuElements/SuggestedDinner.vue'
import ColumnWrapper from '@/components/Elements/ColumnWrapper.vue'
export default {
  components: {
    Desserts,
    FirstCourse,
    SecondCourse,
    SuggestedDinner,
    ColumnWrapper
  },
  props: {
    id: undefined
  },
  created: function () {
    this.student = this.$attrs.student
  },
  data: () => ({
    student: {}
  }),
  methods: {
    changeView: function () {
      this.$emit('changeView')
    },
    detectElementChange: function (item) {
      this.$emit('changedColumn',
        item
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diaryType/MenuDiary/MenuDiaryHeader.vue